export const URL_ITEM_DETAIL_V4 = '/api/v4/item/get';

export const URL_ITEM_SNAPSHOT = '/api/v2/snapshot/get';
export const URL_ITEM_SNAPSHOT_V4 = '/api/v4/item/snapshot/get';
export const URL_BATCH_ITEM_V2 = '/api/v2/item/get_list';

export const URL_ITEM_INSTALLMENT_PLAN = '/api/v2/item/get_installment_plans';
export const URL_ITEM_INSTALLMENT_PLAN_V4 =
  '/api/v4/item/get_installment_plans';

export const URL_GET_SHIPPING_FEE_BY_ADDRESS =
  '/shop/${shopId}/item/${itemId}/shipping_info_to_address/';
export const URL_GET_SHIPPING_FEE_BY_ADDRESS_V4 =
  '/api/v4/pdp/get_shipping_info';
export const URL_GET_SHIPPING_FEE_BY_ADDRESS_V5 = '/api/v4/pdp/get_shipping';

export const URL_BATCH_ITEM_V4 = '/api/v4/item/get_list';
